module.exports = __webpack_public_path__ + "img/img05.9ec8f8f8.svg";